import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import ActionButton from "../account/ActionButton";
import { useNavigate } from "react-router-dom";

const ChangePaymentMethodConfirmation = ({ saveSuccess }) => {

  const navigate = useNavigate();

  return (
    <Box sx={{ mt: 10 }}>
      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {saveSuccess ? (
          <>
            <CheckCircleIcon sx={{ mb: 4, fontSize: "82px", color: "success" }} />
            <Typography marginBottom={1} fontWeight={600} variant='h5' gutterBottom>
              Payment details updated
            </Typography>
            <Typography marginBottom={4} variant='subtitle1' gutterBottom>
              Thank you for updating your payment details{" "}
            </Typography>
          </>
        ) : (
          <>
            <CancelIcon sx={{ mb: 4, fontSize: "82px", color: "error" }} />
            <Typography marginBottom={1} fontWeight={600} variant='h5' gutterBottom>
              Save failed
            </Typography>
            <Typography variant='subtitle1' gutterBottom>
              It looks like we couldn't update your payment details.
            </Typography>
            <Typography marginBottom={2} variant='subtitle1' gutterBottom>
              Please double check your payment details and try again when you are ready.
            </Typography>
            <Typography marginBottom={4} variant='body2' gutterBottom>
              If the issue persists, feel free to contact our support team for assistance.
            </Typography>
          </>
        )}
        <ActionButton
          variant='contained'
          buttonColor='secondary.main'
          buttonTextColor='primary.contrastText'
          borderColor='transparent'
          hoverColor='primary.contrastText'
          hoverBorderColor='secondary.main'
          hoverTextColor='secondary.main'
          buttonTitle='Return Home'
          onClick={() => { navigate("/") }}
        />
      </Box>
    </Box>
  );
};

ChangePaymentMethodConfirmation.propTypes = {
  saveSuccess: PropTypes.bool.isRequired,
};

export default ChangePaymentMethodConfirmation;
